import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action, reaction } from "mobx";

export default class CommonStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    reaction(
      () => this.token,
      (token) => {
        if (token) {
          window.localStorage.setItem("jwt", token);
        } 
      }
    );
  }

  @observable token: string | null = null;
  @observable appLoaded = false;

  @action setToken = (token: string | null) => {
    if(token === null)
    {
      window.localStorage.removeItem("jwt");
    }
    this.token = token;
  };

  @action setAppLoaded = () => {
    this.appLoaded = true;
  };
}
